import { isNumber } from 'lodash';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

export interface INavigationCollapseModel {
    destroy: () => void;
    /** ai 生成单个画布 */
    isAiCreate: boolean;
    setIsAiCreate: (payload: boolean) => void;
    /** ai 重新生成单个画布 */
    isAiRegen: boolean;
    regenIndex: number;
    setAiRegen: (payload: { regenIndex?: number; isAiRegen: boolean }) => void;
    closeAiPPTPrompt: () => void;
}

const useNavigationCollapseModel = create<INavigationCollapseModel>()(
    immer((set) => ({
        destroy: () =>
            set((state) => {
                state.isAiCreate = false;
                state.isAiRegen = false;
            }),
        closeAiPPTPrompt: () =>
            set((state) => {
                state.isAiCreate = false;
                state.isAiRegen = false;
            }),

        isAiCreate: false,
        setIsAiCreate: (payload) =>
            set((state) => {
                state.isAiCreate = payload;
            }),

        regenIndex: 0,
        isAiRegen: false,
        setAiRegen: (payload) =>
            set((state) => {
                state.isAiRegen = payload.isAiRegen;
                if (isNumber(payload.regenIndex)) {
                    state.regenIndex = payload.regenIndex;
                }
            }),
    })),
);

export { useNavigationCollapseModel };
export const getNavigationCollapseModel = () => useNavigationCollapseModel.getState();
